import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {withRouter} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import * as AdminActions from '../../../store/actions/adminActions';
import Boundary from '../../Boundary.js';

import Student from './Student';
import StudentSearch from './StudentSearch';
import ReactTooltip from 'react-tooltip'

/* global $ */

class Students extends Component {
    constructor(props) {
        super(props);

        this.searchBar = React.createRef();
    }

    componentDidMount(){
        this.init();
        this.initPopovers();
    }

    initPopovers = () => {
        setTimeout(() => {
            $('[data-toggle="popover"]').popover();
        }, 2000);
    }
    componentDidUpdate(props){
        if(props.match.params.courseId !== this.props.match.params.courseId){
            this.init();
        }

        if(props.students !== this.props.students){
            // Init popovers
            this.initPopovers();
        }
    }

    init = () => {
        // console.log("Initting");
        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        if(this.props.studentSubjects){
            if(this.props.studentSubjects.length === 0 && courseIds.length > 0){
                this.props.getSubjectsByCourseId(courseIds, this.props.user.id);
            }
        }

        //this.props.getStudents(courseIds, 0, 10, {}, this.props.user.user.id, this.props.user.id);
    }

    renderStudents = () => {
        return this.props.students.map((s, i) => {
            return <Student key={i} id={s.id} student={s} socket={this.props.socket} />
        })
    }
    loadMore = () => {
        let courseIds = [];
        if(this.props.match.params.courseId){
            courseIds = [this.props.match.params.courseId];
        }else{
            courseIds = this.props.adminCourses.map(c => c.id);
        }

        this.setState({courseIds: courseIds});

        if(this.props.studentSubjects){
            if(this.props.studentSubjects.length === 0 && courseIds.length > 0){
                //this.props.getSubjectsByCourseId(courseIds, this.props.user.id);
            }
        }

        // Get search query:
        let s = this.props.location.search.substr(1);
        let apiQuery = {};

        s.split('&').map(q => {
            let localQ = q.split('=')[0];
            if (q.split('=')[0] === "tags") {
                return apiQuery[q.split('=')[0]] = q.split('=')[1].split(',');

            } else {
                if (q.split('=')[1] !== "Invalid date" && q.split('=')[1] !== "Invalid%20date") {
                    return apiQuery[q.split('=')[0]] = q.split('=')[1];
                }
            }
        })

        // console.log("Got seearch", apiQuery);
        this.props.loadMoreStudents(courseIds, this.props.students.length, 10, apiQuery, this.props.user.user.id, this.props.user.id);
    }

    render(){
        return (
            <div>
                <StudentSearch />

                {this.props.students ?
                    this.renderStudents()
                : null}

                {(this.props.studentCount > this.props.students.length) && !this.props.loadingStudents ?
                    <div className="text-center">
                        <button className="btn btn-danger" onClick={e => {
                        // console.log("TH", this.searchBar);
                        this.loadMore()
                    }}><i className="zmdi zmdi-refresh" /> &nbsp; Load More</button>
                    </div>

                : null}


                <ReactTooltip effect="solid" />
            </div>
        )
    }
}


const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getStudents: (courseIds, filter, userId, token) => {
        dispatch(AdminActions.getStudents(courseIds, filter, userId, token));
    },
    getSubjectsByCourseId: (courseIds, token) => {
        dispatch(AdminActions.getStudentSubjects(courseIds, token));
    },
    loadMoreStudents: (courseIds, skip, limit, query, userId, token) => {
        dispatch(AdminActions.loadMoreStudents(courseIds, skip, limit, query, userId, token));
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Students));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Students/Students.js